<template>
  <div class="th-cart-page">
    <h2 class="th-title">Keranjang</h2>
    <div v-if="carts.length" class="flex flex-col lg:flex-row">
      <div class="th-cart-page-list w-full lg:w-3/5">
        <div class="th-card mb-5 p-4" v-for="(cart, i) in carts" :key="i">
          <!-- <div style="margin-right: 35px" class="content-checkbox">
            <va-checkbox
              :checked="cart.isSelected"
              @change="(val) => onChange(val, cart)"
            />
            <CardCart :meta="cart" :exclude="['price']" :imgWidth="100" />
          </div> -->
          <div class="lg:hidden flex justify-between items-center gap-4">
            <!-- <va-checkbox
              class="hidden"
              :checked="cart.isSelected"
              @change="(val) => onChange(val, cart)"
            /> -->
            <div class="flex items-center gap-6">
              <img
                class="w-14 h-14 sm:w-18 sm:h-18 rounded-md"
                :src="cart.imgSrc ? cart.imgSrc : '/img/thumbnail/empty.png'"
                :alt="cart.title"
              />
              <div class="">
                <div class="text-md sm:text-lg font-bold">{{ cart.title }}</div>
                <div class="text-sm text-gray-700 font-light">
                  {{ cart.by }}
                </div>
                <div class="text-md font-bold">
                  {{ thousandPrice(cart.price) }}
                </div>
              </div>
            </div>
            <div
              @click.prevent="removeFromCart(cart.key)"
              class="content-action th-hover-pointer"
            >
              <trash-icon />
            </div>
          </div>
          <div class="hidden lg:flex items-center lg:justify-between">
            <div class="flex items-center gap-6">
              <va-checkbox
                :checked="cart.isSelected"
                @change="(val) => onChange(val, cart)"
              />
              <img
                class="w-16 h-16 rounded-md"
                :src="cart.imgSrc ? cart.imgSrc : '/img/thumbnail/empty.png'"
                :alt="cart.title"
              />
              <div>
                <div class="text-lg font-bold">{{ cart.title }}</div>
                <div class="text-sm text-gray-700 font-light">
                  {{ cart.by }}
                </div>
              </div>
            </div>
            <div class="flex items-center gap-6">
              <div class="content-price">
                <h3>{{ thousandPrice(cart.price) }}</h3>
              </div>
              <div
                @click.prevent="removeFromCart(cart.key)"
                class="content-action th-hover-pointer"
              >
                <trash-icon />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th-cart-page-total th-card w-full lg:w-2/5 h-44">
        <div class="total-content">
          <div>Total:</div>
          <h1>
            <animated-number
              :value="totalCartPrice"
              :formatValue="thousandPrice"
              :duration="500"
            />
          </h1>
        </div>
        <div class="total-content-action">
          <va-button
            @click="toPayment"
            type="primary"
            :disabled="totalCartPrice !== 0 ? false : true"
            class="total-cart-action-button"
            block
            >{{
              sessionId ? "Lanjut ke Pembayaran" : "Masuk untuk Pembayaran"
            }}</va-button
          >
        </div>
      </div>
    </div>
    <div v-else class="h-full flex justify-center mt-20">
      Belum ada course dikeranjang.
    </div>
  </div>
</template>

<script>
import thousandPrice from '@/helpers/thousandPrice'
import AnimatedNumber from 'animated-number-vue'
// const CardCart = () => import('@/components/App/CardCart')
const TrashIcon = () => import('@/components/Icon/Trash')

export default {
  components: {
    // CardCart,
    TrashIcon,
    AnimatedNumber,
  },
  computed: {
    carts() { return this.$store.state.cart.carts },
    sessionId() { return this.$store.state.user.sessionId },
    totalCartPrice() { return this.$store.getters['cart/totalCartPrice'] },
  },
  methods: {
    removeFromCart(key) {
      this.$store.commit('cart/REMOVE_CART_ITEM', key)
    },
    onChange(value, cart) {
      const payload = {
        key: cart.key,
        isSelected: value,
      }
      this.$store.commit('cart/SET_SELECTED_STATUS_CART_ITEM', payload)
      // if (value) this.checkedCarts.push(cart)
      // else this.checkedCarts = this.checkedCarts.filter(oldCart => cart.key !== oldCart.key)
    },
    async toPayment() {
      // if (routeName === this.$route.name) return
      // this.$store.commit('SET_STATE', { currentMenu: '' })
      // this.$router.push({ name: routeName })

      if (this.sessionId) {
        const courseIds = this.carts.map(course => {
          return course.key
        })

        const url = await this.$store.dispatch('transaction/BUY_COURSE', { dataCourse: courseIds })
        window.open(url)
      } else {
        this.$router.push({ name: 'Masuk', query: { redirect: this.$route.path } })
      }
    },
  },
  data() {
    return {
      checkedCarts: [],
      thousandPrice,
    }
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
.th-cart-page {
  &-list {
    margin-right: 28px;
    .th-cart-page-list-content {
      display: flex;
      align-items: center;
      width: 100%;

      .content {
        &-checkbox,
        &-action,
        &-price {
          display: flex;
          align-items: center;
        }

        &-checkbox {
          width: 85%;

          .va-checkbox-label.va-checkbox-checked {
            .va-checkbox-inner {
              &-check {
                &::before {
                  font-size: 17px !important;
                }
              }
            }
          }
          .va-checkbox-inner {
            padding: 8px 4px !important;
            width: 32px !important;
            height: 32px !important;
          }
          .th-cart-list {
            &-meta {
              &-title,
              &-by {
                font-size: 14px;
              }
            }

            &-image {
              margin-right: 21px;
              margin-left: 29px;
            }
          }
        }

        &-action {
          justify-content: flex-end;
          width: 15%;
        }

        &-price {
          white-space: nowrap;
        }
      }
    }
  }

  &-total {
    padding: 24px 16px 16px;

    .total {
      &-content {
        margin-bottom: 30px;
        div {
          font-size: 20px;
          margin-bottom: 4px;
        }

        h1 {
          color: $black;
        }
      }
    }
  }
}
</style>
